export const IconAcquirers = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="24px"
			height="24px"
			viewBox="0 -960 960 960"
			fill="#1f1f1f">
			<path d="M340.62-140q-84.08 0-142.35-58.27Q140-256.54 140-340.75q0-35.16 12.04-68.47 12.04-33.32 34.5-60.39l141.23-169.85L264-767.77q-9.23-18.07 1.12-35.15Q275.46-820 296.16-820h367.68q20.7 0 31.04 17.08 10.35 17.08 1.12 35.15l-63.77 128.31 141.23 169.85q22.46 27.07 34.5 60.39Q820-375.91 820-340.75q0 84.21-58.51 142.48Q702.97-140 619.38-140H340.62Zm139.31-190.39q-29.85 0-51.04-21.26-21.2-21.26-21.2-51.11 0-29.86 21.26-51.05Q450.21-475 480.07-475q29.85 0 51.04 21.26 21.2 21.26 21.2 51.12 0 29.85-21.26 51.04-21.26 21.19-51.12 21.19ZM382.69-665h195L625-760H335l47.69 95Zm-42.07 465h278.76q58.94 0 99.78-41.04T760-340.7q0-24.69-8.5-47.95-8.5-23.27-24.27-42.04L582.15-605h-203.3l-145.7 173.69q-15.77 18.77-24.46 42.4-8.69 23.62-8.69 48.28 0 58.55 41.04 99.59Q282.08-200 340.62-200Z" />
		</svg>
	);
};
